import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { api, apiError } from "@/lib/api";
import { inputCls, Field, GoldButton } from "@/components/app/widgets";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Sign in with your new password.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Choose a new password"
      sub="Minimum 8 characters."
      footer={
        <Link to="/login" className="text-[#D4AF37] hover:brightness-110">
          Back to sign in
        </Link>
      }
    >
      {!token ? (
        <p data-testid="reset-invalid" className="text-sm text-red-400">
          This reset link is missing its token. Request a new one from the sign-in page.
        </p>
      ) : (
        <form onSubmit={submit} data-testid="reset-form" className="space-y-5">
          <Field label="New password">
            <input
              type="password" required minLength={8} autoComplete="new-password"
              data-testid="reset-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className={inputCls} placeholder="••••••••"
            />
          </Field>
          <GoldButton type="submit" disabled={loading} data-testid="reset-submit-button" className="w-full py-3">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update Password"}
          </GoldButton>
        </form>
      )}
    </AuthShell>
  );
}
